export default {
  namespaced: true,
  state: {
    loading: true,
  },
  mutations: {
    loading_start(state) {
      state.loading = true
    },
    loading_end(state) {
      state.loading = false
    },
  },
  getters: {
    loading: (state) => state.loading,
  },
  actions: {},
}
